export const EU_COUNTRIES = [
    { code: 'SK', label: 'SK — Slovensko' },
    { code: 'CZ', label: 'CZ — Česko' },
    { code: 'AT', label: 'AT — Rakúsko' },
    { code: 'BE', label: 'BE — Belgicko' },
    { code: 'BG', label: 'BG — Bulharsko' },
    { code: 'CY', label: 'CY — Cyprus' },
    { code: 'DE', label: 'DE — Nemecko' },
    { code: 'DK', label: 'DK — Dánsko' },
    { code: 'EE', label: 'EE — Estónsko' },
    { code: 'ES', label: 'ES — Španielsko' },
    { code: 'FI', label: 'FI — Fínsko' },
    { code: 'FR', label: 'FR — Francúzsko' },
    { code: 'GR', label: 'GR — Grécko' },
    { code: 'HR', label: 'HR — Chorvátsko' },
    { code: 'HU', label: 'HU — Maďarsko' },
    { code: 'IE', label: 'IE — Írsko' },
    { code: 'IT', label: 'IT — Taliansko' },
    { code: 'LT', label: 'LT — Litva' },
    { code: 'LU', label: 'LU — Luxembursko' },
    { code: 'LV', label: 'LV — Lotyšsko' },
    { code: 'MT', label: 'MT — Malta' },
    { code: 'NL', label: 'NL — Holandsko' },
    { code: 'PL', label: 'PL — Poľsko' },
    { code: 'PT', label: 'PT — Portugalsko' },
    { code: 'RO', label: 'RO — Rumunsko' },
    { code: 'SE', label: 'SE — Švédsko' },
    { code: 'SI', label: 'SI — Slovinsko' },
];

export const EU_COUNTRY_CODES = EU_COUNTRIES.map(c => c.code);
